import { render, staticRenderFns } from "./YourAboutToExpireBadgesBanner.vue?vue&type=template&id=65f622fa&scoped=true"
import script from "./YourAboutToExpireBadgesBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./YourAboutToExpireBadgesBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourAboutToExpireBadgesBanner.vue?vue&type=style&index=0&id=65f622fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f622fa",
  null
  
)

export default component.exports